import { render, staticRenderFns } from "./AccountMenuPage.vue?vue&type=template&id=4141738c"
import script from "./AccountMenuPage.vue?vue&type=script&lang=js"
export * from "./AccountMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports